// extracted by mini-css-extract-plugin
module.exports = {"button":"BidButton_button__7JqKC"};